export default {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  HOME: 'home',
  PAGE: 'page',
  PAGE_EDIT: 'pageEdit',
  UPLOAD: 'upload',
  GALLERY: 'gallery',
  GALLERY_CREATE: 'galleryCreate',
  GALLERY_DETAIL: 'galleryDetail',
  NOT_FOUND: 'notFound',
  CONTACT: 'contact',
  ERROR: 'error',
  MENU: 'menu',
  MENU_UPLOAD: 'menu-upload',
};
